import React, { memo } from 'react';

const PaymentsVerification = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.2674 1.83331H2.73411C2.25519 1.8355 1.79651 2.02673 1.45785 2.36538C1.1192 2.70404 0.927973 3.16272 0.925781 3.64165V16.3583C0.927973 16.8372 1.1192 17.2959 1.45785 17.6346C1.79651 17.9732 2.25519 18.1645 2.73411 18.1667H17.2674C17.7464 18.1645 18.2051 17.9732 18.5437 17.6346C18.8824 17.2959 19.0736 16.8372 19.0758 16.3583V3.64165C19.0736 3.16272 18.8824 2.70404 18.5437 2.36538C18.2051 2.02673 17.7464 1.8355 17.2674 1.83331ZM17.2674 16.3583H2.73411V3.64165H17.2674V16.3583Z"
      fill="#6B6C7B"
    />
    <path
      d="M7.27591 5.45831H4.55091C4.04925 5.45831 3.64258 5.86499 3.64258 6.36665C3.64258 6.86831 4.04925 7.27498 4.55091 7.27498H7.27591C7.77757 7.27498 8.18425 6.86831 8.18425 6.36665C8.18425 5.86499 7.77757 5.45831 7.27591 5.45831Z"
      fill="#6B6C7B"
    />
    <path
      d="M7.27591 9.09167H4.55091C4.04925 9.09167 3.64258 9.49835 3.64258 10C3.64258 10.5017 4.04925 10.9083 4.55091 10.9083H7.27591C7.77757 10.9083 8.18425 10.5017 8.18425 10C8.18425 9.49835 7.77757 9.09167 7.27591 9.09167Z"
      fill="#6B6C7B"
    />
    <path
      d="M7.27591 12.725H4.55091C4.04925 12.725 3.64258 13.1317 3.64258 13.6333C3.64258 14.135 4.04925 14.5416 4.55091 14.5416H7.27591C7.77757 14.5416 8.18425 14.135 8.18425 13.6333C8.18425 13.1317 7.77757 12.725 7.27591 12.725Z"
      fill="#6B6C7B"
    />
    <path
      d="M14.7317 9.74085C14.7317 11.3927 13.3927 12.7317 11.7409 12.7317C10.0891 12.7317 8.75 11.3927 8.75 9.74085C8.75 8.08905 10.0891 6.75 11.7409 6.75C13.3927 6.75 14.7317 8.08905 14.7317 9.74085Z"
      stroke="#6B6C7B"
      strokeWidth="1.5"
    />
    <line
      x1="14.5743"
      y1="12.3004"
      x2="16.6639"
      y2="14.3899"
      stroke="#6B6C7B"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export default memo(PaymentsVerification);
